export default "/images/ico-save-draft.svg?62f9859a4b00b0736b9c43f88d5761f9";